
import { all } from 'redux-saga/effects';
import dataSaga from '../sagas';

function* rootSaga() {
  yield all([
    dataSaga(),
    // Add other sagas here if needed
  ]);
}

export default rootSaga;
